import { useState } from 'react';
import { useT } from '@hana/i18n';
import './bookingI18n';
import { IconChevronLeft, IconDots } from '@tabler/icons-react';
import { Button, Chip } from '@hana/ui';
import { PageHeader } from '@hana/shell';
import { countdown, rqStatus, shipStatus } from './booking';
import { BOOKING_VESSELS } from './fixtures';
import { MENU } from './BookingPadDetail';
import { padDetail } from './padDetail';
import type { BookingRequest } from './types';
import s from './bookingPhoneDetail.module.css';

// Mint-Booking-Phone khung 2 (390): chi tiết RQ — khách + tuyến, thẻ Thông tin booking (hàng nhãn / giá trị), Nhật ký job; thanh dưới ⋯ + nút chính. Chỉ đọc.
const DOT = { amber: 'var(--d-amber)', blue: 'var(--d-blue)', gray: 'var(--d-gray)' } as const;

export function BookingPhoneDetail({ r, onBack, onWrite }: { r: BookingRequest; onBack: () => void; onWrite: () => void }) {
  const t = useT();
  const [menu, setMenu] = useState(false);
  const d = padDetail(r);
  const v = BOOKING_VESSELS[r.vessel] ?? BOOKING_VESSELS['none']!;
  const ship = shipStatus(r);
  const done = r.tab === 'done';
  const cdSi = countdown(r.siCutoff, done || !!r.bookingNo);
  const cdCy = countdown(r.cyCutoff, done);
  const facts: Array<{ k: string; v: string; c?: string }> = [
    { k: 'Hãng tàu', v: r.carrier },
    { k: 'Số booking', v: r.bookingNo ?? 'Chưa có', c: r.bookingNo ? undefined : 'warn' },
    { k: 'Tàu / chuyến', v: v.name },
    { k: 'Cut-off SI', v: `${r.siCutoff ?? '—'}${cdSi ? ` · ${cdSi.k}` : ''}` },
    { k: 'Closing CY', v: `${r.cyCutoff ?? '—'}${cdCy ? ` · ${cdCy.k}` : ''}`, c: r.cyWarn ? 'err' : undefined },
    { k: 'Chủ job (BKG)', v: r.owner ?? 'Chưa nhận' },
  ];
  return (
    <>
      <PageHeader
        title={r.id}
        sub={d.sub}
        noFind
        lead={
          <button type="button" className={s.back} aria-label="Quay lại danh sách" title="Quay lại danh sách" onClick={onBack}>
            <IconChevronLeft size={20} aria-hidden="true" />
          </button>
        }
        meta={
          <Chip dot={DOT[ship.dot]} label={rqStatus(r)}>
            {rqStatus(r)}
          </Chip>
        }
      />
      <div className={s.main}>
        <section className={s.card}>
          <b className={s.cus}>{r.customer}</b>
          <div className={s.tx2}>{`${r.route} · ${r.cont} · Sale ${r.sale}`}</div>
        </section>
        <section aria-label="Thông tin booking" className={s.facts}>
          {facts.map((f) => (
            <div key={f.k} className={s.fr}>
              <span className={s.lb}>{f.k}</span>
              <b className={`${s.fv} ${f.c === 'warn' ? s.warn : f.c === 'err' ? s.err : ''}`}>{f.v}</b>
            </div>
          ))}
        </section>
        <section aria-label="Nhật ký" className={s.log}>
          <b>{t('bkx.jobLog')}</b>
          {d.log.map((l) => (
            <div key={l.k} className={s.lg}>
              <span className={s.ldot} style={{ background: l.dot }} />
              <span className={s.grow}>{l.k}</span>
              <span className={s.lb}>{l.when}</span>
            </div>
          ))}
        </section>
      </div>
      <div className={s.foot}>
        <Button variant="ghost" className={s.more} icon={<IconDots size={20} aria-hidden="true" />} aria-label="Thao tác khác" aria-haspopup="menu" aria-expanded={menu} onClick={() => setMenu((x) => !x)} />
        <Button variant="primary" className={s.pri} onClick={onWrite}>
          {d.primary}
        </Button>
        {menu && (
          <div role="menu" aria-label="Thao tác RQ" className={s.sheet}>
            {MENU.map((m) => (
              <div key={m.k}>
                {m.g && <div className={s.mg}>{m.g}</div>}
                <button type="button" role="menuitem" className={s.mi} onClick={() => { setMenu(false); onWrite(); }}>
                  {m.k}
                  <span className={s.tip}>{m.tip}</span>
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
}
